import React, { Component } from 'react';
import Switch from 'react-switch';
import '../../../css/GenericServices/MyServicesSettingsGS.css';
import Header from '../../Shared/Header';
import Footer from '../../Shared/Footer';
import Footer2 from '../../Shared/Footer2';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import TitleDescription from '../../../Data/Shared/TitleDescription.json';
import { PortAlphaSorting } from '../../../Services/utils/AlphaSorting';
import { ApiCall } from '../../../Services/utils/ApiCall';
import { utilityBaseURL } from '../../../Services/config/apiGateway';
import {
  ALLPORTTERMINALS_ENDPOIN, SINGLE_USER_PORT_PREFERENCE_ENDPOINT
} from '../../../Services/config/apiEndPoints';
import { AES, enc } from 'crypto-js';
import { connect } from 'react-redux';

class MyServicesSettingsGS extends Component {
  constructor() {
    super();
    this.state = {
      terminalData: [],
      st: {},
      apiStack: []
    };
    this.handleChange = this.handleChange.bind(this);
  }
  componentWillMount() {
    ApiCall(
      'GET',
      utilityBaseURL + ALLPORTTERMINALS_ENDPOIN,
      {},
      {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    ).then((data) => {
      if (data.flag != -1) {
        if (data.flag == 500) {
          console.log('I am 500!');
        } else {
          console.log('I am 200!');
          data = PortAlphaSorting(data);
          this.setState({ terminalData: data }, () => {
            let st = {};
            this.state.terminalData.forEach((s, index) => {
              st[s.portId] = false;
            });
            this.setState({ st: st }, () => this.getSettingsData());
          });
        }
      }
    });
  }
  toggleSwitchApiCall(portId) {
    if (this.state.apiStack.indexOf(portId) == -1) {
      let st = this.state.st;
      var currentStatus = st[portId];
      st[portId] = !st[portId];
      var apiStack = this.state.apiStack;
      apiStack.push(portId);
      this.setState({ st: st, apiStack: apiStack }, () => {
        ApiCall(
          'PUT',
          utilityBaseURL + SINGLE_USER_PORT_PREFERENCE_ENDPOINT,
          {
            "preference": {
              "terminalId": portId,
              "terminalName": "string"
            },
            "selected": !currentStatus,
            "user": this.props.userProfileDataR?.userEmail
          },
          {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        ).then((data) => {
          if (data.flag != -1) {
            console.log(portId, ' : state toggled, now - ', !currentStatus)
          }
          else {
            let std = this.state.st;
            st[portId] = currentStatus;
            this.setState({ st: std }, () => {
            });
          }
          var apiStackd = this.state.apiStack;
          apiStackd.splice(apiStackd.indexOf(portId), 1)
          this.setState({ apiStack: apiStackd });
        });
      });
    }
  }
  handleChange(checked) {
    this.setState({ checked });
  }
  getSettingsData() {
    ApiCall(
      'GET',
      utilityBaseURL + SINGLE_USER_PORT_PREFERENCE_ENDPOINT,
      {},
      {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    ).then((data) => {
      if (data.flag != -1) {
        console.log('I am 200!');
        let st = this.state.st;
        data.portIds.forEach((p) => (st[p] = true));
        this.setState({ st: st });
      }
    });
  }
  render() {
    return (
      <div class="csoutercolor">
        <MetaDecorator title={TitleDescription.MyServiceSettingsGSTitle} description={TitleDescription.MyServiceSettingsGSDescription} />
        <Header tilesFetched={() => { }} />
        <div class="csnofullServicesSettings">
          <div id="csnobox1ServicesSettings">
            <nav class="ServicesSettingsNavBar">
              <div className="ServicesSettingsNavBarHeading">
                <small id="ServicesSettingsNavBarHeadingValue">My Services</small>
              </div>
            </nav>
            <hr className='navbarhr' />
            <div class="toppartServicesSettings">
              <div class="ServicesSettingsUpperNoteDiv">
                <small class="ServicesSettingsLowerNote">Enable the services which you can provide.</small>
              </div>
              <div class="ServicesSettingsOuterContainerDiv">
                <div class="ServicesSettingsLeftOuterDiv">
                  {(this.state.terminalData.map((s, index) => {
                    return (
                      <div class="ServicesSettingsLeftSideDiv" key={index}>
                        <>
                          <div class="ServicesSettingsWhiteContainerdiv">
                            <div class="ServicesSettingsLeftPartNumberDiv">
                              <small class="ServicesSettingsLeftPartNumber">{index + 1}</small>
                            </div>
                            <div class="ServicesSettingsRightPartContainerDiv">
                              <small class="ServicesSettingsHeading">{s.portName.split(':')[0]}</small>
                              <div class="ServicesSettingsArrowDiv">
                                <Switch
                                  onChange={() => {
                                    this.toggleSwitchApiCall(s.portId)
                                  }}
                                  checked={this.state.st[s.portId]}
                                  uncheckedIcon={false}
                                  checkedIcon={false}
                                />
                              </div>
                            </div>
                          </div>
                        </>
                      </div>
                    );
                  }))}
                </div>
              </div>
              <div class="ServicesSettingsLowerNoteDiv">
                <small class="ServicesSettingsLowerNote">Please contact <small class="ServicesSettingsRedNote">Customer Support</small> to add new service here.</small>
              </div>
            </div>
          </div>
        </div>
        <div class="cs2footer11ServicesSettings">
          <Footer />
        </div>
        <div class="cs2footer22ServicesSettings">
          <Footer2 />
        </div>
      </div>
    );
  }
}
function mapStateToProps(state) {
  if (state.userProfileInfoReducer.data) {
    return {
      userProfileDataR: JSON.parse(AES.decrypt(state.userProfileInfoReducer.data, 'TPT_CARGO_CONNECT').toString(enc.Utf8))
    }
  }
}
export default connect(mapStateToProps)(MyServicesSettingsGS); 